import { Add } from 'iconsax-react'

import { weCheckPalette } from '@/utils/palette/weCheckPalette'

interface FilterChipProps {
  label: string
  value: string
  onClick: () => void
}

export const FilterChip = ({ label, value, onClick }: FilterChipProps) => (
  <button
    type="button"
    onClick={onClick}
    className="flex items-center gap-2 rounded-lg border border-neutralColor5 bg-baseColorHighlight px-3 py-2 text-sm text-neutralColor"
  >
    <span>{value ? `${label}: ${value}` : label}</span>
    <Add size="16" color={weCheckPalette.neutralColor60} />
  </button>
)
